function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
});

const I3Tabs = ({
  classes
}) => {
  const _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

  const handleChange = (event, value) => {
    setValue(value);
  };

  return React.createElement("div", {
    className: classes.root
  }, React.createElement(AppBar, {
    position: "static"
  }, React.createElement(Tabs, {
    value: value,
    onChange: handleChange
  }, React.createElement(Tab, {
    label: "Item One"
  }), React.createElement(Tab, {
    label: "Item Two"
  }))), value === 0 && React.createElement(Typography, {
    component: "div",
    style: {
      padding: 8 * 3
    }
  }, "Item One"), value === 1 && React.createElement(Typography, {
    component: "div",
    style: {
      padding: 8 * 3
    }
  }, "Item Two"));
};

I3Tabs.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(I3Tabs);